import { render } from "./Textcarousel.vue?vue&type=template&id=ab8c1462"
import script from "./Textcarousel.vue?vue&type=script&lang=js"
export * from "./Textcarousel.vue?vue&type=script&lang=js"

import "./Textcarousel.vue?vue&type=style&index=0&id=ab8c1462&lang=css"
script.render = render

export default script